import React, { Component } from 'react'
import { Section } from '../../../components'
import BidSubmission from './elements/BidSubmission'
import DisplayDummy from './elements/DisplayDummy'
import ExtensionTime from './elements/ExtensionTime'
import HideLeadingBidAmount from './elements/HideLeadingBidAmount'
import HideLeadingBidTime from './elements/HideLeadingBidTime'
import MaxExtensionTime from './elements/MaxExtensionTime'
import OpeningPrice from './elements/OpeningPrice'
import ReservePrice from './elements/ReservePrice'
export default class AuctionSealed extends Component {
  render() {
    const {
      auctionType,
      formData,
      isErrOpeningPrice,
      isErrReservePrice,
      editRoleDetail,
      isErrBIDDecrement,
      isErrBIDMinimum,
      isErrBID,
      isErrExtensionMinutes,
      isErrMaxExtensionTime,
      isErrHideLeadingBidTime,
      isErrHideLeadingBidAmount,
      isSetState,
    } = this.props
    return (
      <>
        <Section className="form-row">
          <Section className="form-col col-6">
            {/* opening price  */}
            <OpeningPrice
              auctionType={auctionType}
              formData={formData}
              isErrOpeningPrice={isErrOpeningPrice}
              editRoleDetail={editRoleDetail}
              isSetState={data => {
                isSetState(data)
              }}
            />
          </Section>
          <Section className="form-col col-6">
            {/* reserve  */}
            <ReservePrice
              auctionType={auctionType}
              formData={formData}
              isErrReservePrice={isErrReservePrice}
              editRoleDetail={editRoleDetail}
              isSetState={data => {
                isSetState(data)
              }}
            />
          </Section>
        </Section>

        {/* auction row 2 */}
        <Section className="form-row">
          <Section className="form-col col-6">
            {/* bid submission */}
            <BidSubmission
              formData={formData}
              editRoleDetail={editRoleDetail}
              isErrBIDDecrement={isErrBIDDecrement}
              isErrBIDMinimum={isErrBIDMinimum}
              isErrBID={isErrBID}
              isSetState={data => {
                isSetState(data)
              }}
            />
          </Section>

          {/* extension time and max extension time  */}
          <Section className="form-col col-6">
            {/* extension time */}
            <ExtensionTime
              formData={formData}
              editRoleDetail={editRoleDetail}
              isErrExtensionMinutes={isErrExtensionMinutes}
              isSetState={data => {
                isSetState(data)
              }}
            />

            {/* max extension  */}
            <MaxExtensionTime
              formData={formData}
              editRoleDetail={editRoleDetail}
              isErrMaxExtensionTime={isErrMaxExtensionTime}
              isSetState={data => {
                isSetState(data)
              }}
            />
          </Section>
        </Section>

        <Section className="form-row">
          <Section className="form-col col-6">
            {/* Hide Leading Bid Time before close*/}
            <HideLeadingBidTime
              auctionType={auctionType}
              formData={formData}
              isErrHideLeadingBidTime={isErrHideLeadingBidTime}
              isSetState={data => {
                isSetState(data)
              }}
            />
          </Section>

          <Section className="form-col col-6">
            {/* Hide Leading Bid When Bid Amount Does Not Reach Reserve Price*/}
            <HideLeadingBidAmount
              auctionType={auctionType}
              formData={formData}
              editRoleDetail={editRoleDetail}
              isErrHideLeadingBidAmount={isErrHideLeadingBidAmount}
              isSetState={data => {
                isSetState(data)
              }}
            />
          </Section>
        </Section>

        <Section className="form-row">
          <Section className="form-col col-6">
            {/* Display Dummy  */}
            <DisplayDummy
              formData={formData}
              editRoleDetail={editRoleDetail}
              isSetState={data => {
                isSetState(data)
              }}
            />
          </Section>
        </Section>
      </>
    )
  }
}
